import React, { useEffect, useContext } from 'react';
import { Outlet, useLocation, Link as RouterLink } from 'react-router-dom';



import { Layout, Typography, theme, Tag } from 'antd'
import { connect } from 'react-redux'

import Flex                       from '../components/common/Flex'
import ToggleThemDark             from '../components/navbar/partials/ToggleThemDark'
/*
| IMAGES
*/
import Logo from '../components/navbar/Logo';
import VarexeLogo from '../components/common/VarexeLogo';
/*
| PAGES
*/


import MenuLayout from '../components/navbar/varexe/MenuLayout';
import NavbarTop from '../components/navbar/varexe/navbarTop/NavbarTop';
import NavbarTopDeveloperMode from '../components/navbar/varexe/navbarTop/NavbarTopDeveloperMode';

import {
  FooterPanelProvider,
  DashboardFooterSection,
  FooterPanelTriggerBar,
  TRIGGER_BAR_HEIGHT,
} from '../components/footer-panel';

import NoAccessMessageNotAuthorized from '../components/common/PageExceptions/NoAccessMessageResultNotAuthorized';

import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import Dashboard from '../components/dashboard/Dashboard';

import AppContext from '../context/Context';
import { usePrivileges } from 'helpers/license/usePermissions';
import { version } from '../config';

// import ProductProvider from '../components/e-commerce/ProductProvider';
// import SidePanelModal from '../components/side-panel/SidePanelModal';

// import { CloseButton, Fade } from '../components/common/Toast';
// import { getPageName } from '../helpers/utils';
// import { color } from 'echarts';
// import { Children } from 'react';

// const DashboardRoutes = loadable(() => import('./DashboardRoutes'));


// const mapStateToProps = ({ settings }) => ({

//   isContentMaxWidth: settings.isContentMaxWidth,
//   isAppMaxWidth: settings.isAppMaxWidth,
//   isGrayBackground: settings.isGrayBackground,
//   isSquaredBorders: settings.isSquaredBorders,
//   isCardShadow: settings.isCardShadow,
//   isBorderless: settings.isBorderless,
//   isTopbarFixed: settings.isTopbarFixed,
//   isGrayTopbar: settings.isGrayTopbar,
// })

const DashboardLayout = 
({
  isMenuCollapsed,
  isMobileView,
  location,
  children,
  ...props
}) => {
    
  const { hash, pathname } = useLocation();
  const { license_status } = usePrivileges();

  useEffect(() => {
    
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
    
  }, []);

  const {
    config: { developerMode, showFooterTools },
  } = useContext(AppContext);

  const { token } = theme.useToken();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const height = showFooterTools ? `${TRIGGER_BAR_HEIGHT}px` : '0px';
    document.documentElement.style.setProperty('--trigger-bar-height', height);
    return () => document.documentElement.style.removeProperty('--trigger-bar-height');
  }, [showFooterTools]);

  const { Header, Content, Sider, Footer } = Layout;
  const { Text } = Typography;
  return (
        <div style={{ ['--trigger-bar-height']: showFooterTools ? `${TRIGGER_BAR_HEIGHT}px` : '0px' }}>
          <FooterPanelProvider>
          <Layout
          hasSider
          style={{
            minHeight: '100vh',
            marginBottom: showFooterTools ? `${TRIGGER_BAR_HEIGHT}px` : '0px',
          }}
          >
            <MenuLayout />
              <Layout
                // style={{
                //   display: 'flex',
                //   flexDirection: 'column',
                //   flex: 1,
                //   minHeight: 0,
                //   overflow: 'hidden',
                // }}
              >
              {developerMode && (
              <div className=' ant-alert ant-alert-warning ant-alert-warning-bg' style={{display: "flex"}} >
                  <NavbarTopDeveloperMode />
              </div>                
              )}
              <Header className='varexe-navbar-top' style={{display: "flex", alignItems: "center"}} >
                  <NavbarTop />
              </Header>

                {/* <div
                  style={{
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                  }}
                > */}
                  {/* <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}> */}
                    <Content style={{ overflow: 'visible', minHeight: 'auto' }}>
                      {children}
                    </Content>
                  {/* </div> */}
                  <Footer
                    className="varexe-dashboard-footer"
                    style={{
                      padding: `${token.paddingSM}px ${token.padding}px`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      rowGap: token.marginXS,
                      columnGap: token.marginMD,
                      flexShrink: 0,
                      borderTop: `1px solid ${token.colorBorderSecondary}`,
                      background: token.colorBgContainer,
                    }}
                  >
                    <Text
                      type="secondary"
                      style={{
                        fontSize: token.fontSizeSM,
                        flex: '1 1 220px',
                        minWidth: 0,
                        lineHeight: token.lineHeight,
                      }}
                    >
                      Your security matters. Data is protected and confidential. Questions?{' '}
                      <RouterLink
                        to="/support"
                        style={{
                          color: token.colorLink,
                          fontWeight: token.fontWeightStrong,
                          textDecoration: 'none',
                        }}
                      >
                        Contact Support
                      </RouterLink>
                    </Text>
                    <Tag 
                      aria-label={` Gridbind  application version ${version}`}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: token.marginXS,
                        padding: `${token.paddingXXS}px ${token.paddingSM}px`,

                        flexShrink: 0,
                      }}
                    >
                      <Text
                        style={{
                          margin: 0,
                          fontSize: token.fontSizeSM,
                          fontWeight: token.fontWeightStrong,
                          color: token.colorTextSecondary,
                          letterSpacing: '0.02em',
                          lineHeight: 1,
                        }}
                      >
                         Gridbind 
                      </Text>
                      <span
                        style={{
                          width: 1,
                          height: 12,
                          background: token.colorSplit,
                          flexShrink: 0,
                        }}
                        aria-hidden
                      />
                      <Text
                        style={{
                          margin: 0,
                          fontSize: token.fontSizeSM,
                          fontFamily: token.fontFamilyCode,
                          fontVariantNumeric: 'tabular-nums',
                          color: token.colorText,
                          fontWeight: token.fontWeightStrong,
                          lineHeight: 1,
                        }}
                      >
                        {version}
                      </Text>
                    </Tag >
                  </Footer>
                {/* </div> */}
              </Layout>
            </Layout>
            {showFooterTools && <DashboardFooterSection />}
          {showFooterTools && <FooterPanelTriggerBar />}
          </FooterPanelProvider>
        </div>
  );
};

export default DashboardLayout

